
import useFathom from '@/composables/useFathom';
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'AppNavToggle',

  props: {
    darkModeBg: { type: String, default: '850' }
  },

  setup() {
    const route = useRoute();
    const activeClasses = 'dark:bg-gray-980 text-white rounded-md';
    const isTradePage = computed(() => route.name === 'trade');
    const isFarmPage = computed(() =>
      ['farm', 'farmpool', 'stake-flake', 'singlefarm'].includes(
        route.name as string
      )
    );

    const { trackGoal, Goals } = useFathom();

    return {
      isTradePage,
      isFarmPage,
      activeClasses,
      trackGoal,
      Goals
    };
  }
});
